// ======================================
// Admin Inquiries Page Module
// ======================================

import { apiRequest } from '../../lib/api.js';
import { renderAdminLayout, initAdminLayout } from './admin-layout.js';

export function renderAdminInquiries() {
  const content = `
    <!-- Inquiries Table -->
    <div class="admin-card">
      <div class="admin-card-header" style="display:flex;justify-content:space-between;align-items:center;padding:var(--space-4) var(--space-6);border-bottom:1px solid var(--color-border);">
        <h2 style="margin:0;font-size:16px;">Contact Form Inquiries</h2>
        <button class="btn btn-sm btn-outline" id="refresh-inquiries">↻ Refresh</button>
      </div>
      <div class="admin-table-container">
        <table class="admin-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Message</th>
              <th>Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody id="inquiries-body">
            <tr><td colspan="6" class="loading-cell" style="text-align:center;padding:var(--space-8);">Loading inquiries...</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  `;

  return renderAdminLayout('inquiries', 'Inquiries', content);
}

export async function initAdminInquiries() {
  initAdminLayout();

  const refreshBtn = document.getElementById('refresh-inquiries');
  if (refreshBtn) {
    refreshBtn.addEventListener('click', loadInquiries);
  }

  await loadInquiries();
}

async function loadInquiries() {
  const tbody = document.getElementById('inquiries-body');
  if (!tbody) return;

  try {
    const response = await apiRequest('/inquiries');
    const inquiries = response.data || [];

    if (!inquiries.length) {
      tbody.innerHTML = `
        <tr><td colspan="6" style="text-align:center;padding:var(--space-8);">
          <p style="color:var(--color-text-muted);margin:0;">No inquiries yet.</p>
          <p style="font-size:12px;color:var(--color-text-muted);margin:4px 0 0;">Contact form submissions will appear here.</p>
        </td></tr>
      `;
      return;
    }

    tbody.innerHTML = inquiries.map(inq => `
      <tr>
        <td><strong>${inq.name}</strong></td>
        <td>${inq.email || '-'}</td>
        <td><a href="tel:${inq.phone}">${inq.phone || '-'}</a></td>
        <td style="max-width:250px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${inq.message || '-'}</td>
        <td>${new Date(inq.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })}</td>
        <td><span class="status-badge status-${inq.status || 'new'}">${inq.status || 'new'}</span></td>
      </tr>
    `).join('');
  } catch (error) {
    tbody.innerHTML = '<tr><td colspan="6" style="text-align:center;color:var(--color-error);padding:var(--space-6);">Failed to load inquiries</td></tr>';
  }
}
